import React from 'react'
import {
    BackButton,
    Bloc,
    BlocTextField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue15() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Avez-vous interrogé des banques ou courtiers pour votre projet ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>

            <div className="Container">
                <Bloc
                    key="key121"
                    linked_data_id="tech_solicitation"
                    linked_data_value="personne"
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="Je n’ai sollicité personne"
                />

                <Bloc
                    key="key122"
                    linked_data_id="tech_solicitation"
                    linked_data_value="mabanque"
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="J’ai seulement sollicité ma banque"
                >
                    <Bloc
                        key="keybanque1"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BNP"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/BNP-Paribas_low.jpg"
                    />
                    <Bloc
                        key="keybanque2"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="CIC"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/CIC_low.jpg"
                    />
                    <Bloc
                        key="keybanque3"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="ING"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/ING-banque_low.jpg"
                    />
                    <Bloc
                        key="keybanque4"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="LCL"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/LCL_low.jpg"
                    />
                    <Bloc
                        key="keybanque5"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="AXA"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/axa-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque6"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BPOP"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/banque-pop_low.jpg"
                    />
                    <Bloc
                        key="keybanque7"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BFOBANK"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/bfobank_low.jpg"
                    />
                    <Bloc
                        key="keybanque8"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BOURSORAMA"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/boursorama-banque_low.jpg"
                    />
                    <Bloc
                        key="keybanque9"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="CE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/caisse-epargne_low.jpg"
                    />
                    <Bloc
                        key="keybanque10"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="CA"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/credit-agricole_low.jpg"
                    />
                    <Bloc
                        key="keybanque11"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="CREDIT-COOPERATIF"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/credit-cooperatif_low.jpg"
                    />
                    <Bloc
                        key="keybanque12"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="CREDITMUTUEL"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/creditmut_low.jpg"
                    />
                    <Bloc
                        key="keybanque13"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="FORTUNEO"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/fortuneo-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque14"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BPCE"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/groupe-BPCE_low.jpg"
                    />
                    <Bloc
                        key="keybanque15"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="HELLOBANK"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/hellobank_low.jpg"
                    />
                    <Bloc
                        key="keybanque16"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="HSBC"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/hsbc_low.jpg"
                    />
                    <Bloc
                        key="keybanque17"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="BANQUE-POSTALE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/la_banque_postale_low.jpg"
                    />
                    <Bloc
                        key="keybanque18"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="MONABANQ"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/monabanq_low.jpg"
                    />
                    <Bloc
                        key="keybanque19"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="ORANGE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/orange-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque20"
                        selectable
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_1"
                        linked_data_value="SG"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/societe-generale_low.jpg"
                    />
                </Bloc>

                <Bloc
                    key="key133"
                    linked_data_id="tech_solicitation"
                    linked_data_value="plusieursbanques"
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="J’ai sollicité plusieurs organismes "
                >
                    <Bloc
                        key="keybanque21"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BNP"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/BNP-Paribas_low.jpg"
                    />
                    <Bloc
                        key="keybanque22"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="CIC"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/CIC_low.jpg"
                    />
                    <Bloc
                        key="keybanque23"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="ING"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/ING-banque_low.jpg"
                    />
                    <Bloc
                        key="keybanque24"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="LCL"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/LCL_low.jpg"
                    />
                    <Bloc
                        key="keybanque25"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="AXA"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/axa-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque26"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BPOP"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/banque-pop_low.jpg"
                    />
                    <Bloc
                        key="keybanque27"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BFOBANK"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/bfobank_low.jpg"
                    />
                    <Bloc
                        key="keybanque28"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BOURSORAMA"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/boursorama-banque_low.jpg"
                    />
                    <Bloc
                        key="keybanque29"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="CE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/caisse-epargne_low.jpg"
                    />
                    <Bloc
                        key="keybanque210"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="CA"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/credit-agricole_low.jpg"
                    />
                    <Bloc
                        key="keybanque211"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="CREDIT-COOPERATIF"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/credit-cooperatif_low.jpg"
                    />
                    <Bloc
                        key="keybanque212"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="CREDITMUTUEL"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/creditmut_low.jpg"
                    />
                    <Bloc
                        key="keybanque213"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="FORTUNEO"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/fortuneo-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque214"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BPCE"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/groupe-BPCE_low.jpg"
                    />
                    <Bloc
                        key="keybanque215"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="HELLOBANK"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/hellobank_low.jpg"
                    />
                    <Bloc
                        key="keybanque216"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="HSBC"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/hsbc_low.jpg"
                    />
                    <Bloc
                        key="keybanque217"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="BANQUE-POSTALE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/la_banque_postale_low.jpg"
                    />
                    <Bloc
                        key="keybanque218"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="MONABANQ"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/monabanq_low.jpg"
                    />
                    <Bloc
                        key="keybanque219"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="ORANGE"
                        nbcolumn={2}
                        gauche
                        simpleImage="JPG/orange-bank_low.jpg"
                    />
                    <Bloc
                        key="keybanque220"
                        selectable
                        multi_select
                        alternative_select
                        bgColor="white"
                        linked_data_id="autres_contacts_banque_solicite_2"
                        linked_data_value="SG"
                        nbcolumn={2}
                        droit
                        simpleImage="JPG/societe-generale_low.jpg"
                    />
                </Bloc>

                <Bloc
                    key="key144"
                    linked_data_id="tech_solicitation"
                    linked_data_value="courtiers"
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="J’ai sollicité un ou des courtiers"
                >
                    <BlocTextField
                        key="key145"
                        nbcolumn={1}
                        linked_data_id="autres_contacts_courtier_solicite"
                        label="Nom du ou des courtiers"
                        placeholder="Nom du courtier"
                    />
                </Bloc>
            </div>

            <Conditionnal linked_data_id="tech_solicitation" isNotEmpty>
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={16} />{' '}
                </div>
            </Conditionnal>
        </div>
    )
}
